import { useNavigate } from 'react-router-dom';
import { Tabs } from '../primitives';

export type SettingsDocumentsTab = 'types' | 'property-library';

const ITEMS = [
  { value: 'types', label: 'Types' },
  { value: 'property-library', label: 'Property library' }
] as const;

/**
 * Shared tab strip for /settings/documents. The Types pane manages the org's
 * document_types (the single Type field); the Property library pane manages
 * custom property definitions. The tab state lives on the parent page (types
 * is the default), and we route between them in-place via `onChange`.
 */
export function SettingsDocumentsTabs({
  active,
  onChange
}: {
  active: SettingsDocumentsTab;
  onChange: (next: SettingsDocumentsTab) => void;
}) {
  return (
    <Tabs
      items={ITEMS as unknown as { value: string; label: string }[]}
      value={active}
      onChange={(v) => onChange(v as SettingsDocumentsTab)}
      label="Document settings sections"
      dataTestId="settings-documents-tabs"
    />
  );
}

/**
 * Convenience hook for navigating into a specific tab from elsewhere
 * (e.g. the Subtypes-pane legend link that jumps to Property library).
 * Currently a thin wrapper; useful if sub-turn 3 needs deep-link state.
 */
export function useGoToSettingsDocumentsTab() {
  const navigate = useNavigate();
  return (tab: SettingsDocumentsTab) => {
    navigate(`/settings/documents?tab=${tab}`);
  };
}
